import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';

import { appSelectors } from '/store/toolkits/app/selectors';

import { buzzerNotifications$ } from './buzzerNotifications';
import { BuzzerNotifications } from './types';

class BuzzerAppNotifications<S> {
  private buzzerAppNotifications$: Observable<BuzzerNotifications> | undefined;

  init(store: { getState: () => S }) {
    this.buzzerAppNotifications$ ??= buzzerNotifications$.pipe(
      filter((notification) => {
        const state = store.getState();
        const appID = appSelectors.appID(state as never);

        return !!appID && 'appID' in notification && notification.appID === appID.id;
      })
    );
  }

  get$() {
    if (!this.buzzerAppNotifications$) {
      throw new Error('BuzzerAppNotifications is not initialized');
    }

    return this.buzzerAppNotifications$;
  }
}

export const buzzerAppNotifications = new BuzzerAppNotifications();
